import { Injectable, Output, EventEmitter, ElementRef, signal } from '@angular/core';
import { HttpRequestService } from './http-request.service';
import { Observable, BehaviorSubject, Subject, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import _ from 'lodash';
import { apiURLs } from '../globalcontants';
import { HttpParams } from '@angular/common/http';
import { UserInstances } from '../models/Account/UserInstancesEntity';
import { SiteEntity } from '../models/Account/SiteEntity';
import * as GlobalConst from '../globalcontants';

import * as menulist_data from '../../../assets/json/menu-list.json';
import { Title } from '../title/title.interface';
import * as appApiResources from '../../shared/globalcontants';
import { APIServiceProviderService } from '../../shared/services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { ApplicationUserEntity } from '../models/Account/ApplicationUserEntity';
import { UIMenuEntity } from '../models/Application/UIMenuEntity';
import { PrevilegeAuthorizationService } from 'src/app/authorization/services/privilege-authorization.service';
import { LoginAuthentication, GetCallPayloadEntity, GetCallInvDetailsEntity } from '../models/Utilities/CommonEntity';
import { FormGroup } from '@angular/forms';
import { InventoryService } from 'src/app/inventory/inventory.service';
import { TransferDetailEntity, UrlConfig } from '../models/Transactions/TransferDetailEntity';
import moment from 'moment-timezone';
import { LocalTranslationService } from 'src/app/core/services/local-translate.service';
import * as constants from '../../../app/shared/globalcontants';
import DOMPurify from 'dompurify';
import { AdDataModel } from 'src/app/msal-module/azure-ad.interface';
import { ConfigService } from 'src/app/config.service';
import { Router, NavigationExtras } from '@angular/router';
import * as myGlobals from '../../shared/globalcontants';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ClassesLookUpPost } from '../models/Inventory/InventoryLookUpEntity';
import { MatDialog } from '@angular/material/dialog';
import { PopupComponent } from 'src/app/shared/popup/popup.component';
import { ReceivingService } from 'src/app/receiving/shared/services/APIServices/ReceivingService';
@Injectable({ providedIn: 'root' })
export class  CommonService {
  inputType: string;
  popupDialogText: string;
  enableIdleTimeOut: boolean = false;
  public IntegrationConfig: any;
  unCommitedAmount: number;
  ExpireDate: any;
  capexProjectName: string;
  tenatconfig: any;
  locationTypeId: number;
  adAuthority: string;
  autoComplete: MatAutocompleteTrigger;
  autoCompleteSearchText: ElementRef;
  totalMiscCharges: number = 0;
  passwordComplexTenantConfig: Array<any> = [];
  /** Idle seconds for ng-idle; kept in sync with `idleTimeout` / `session` in localStorage. */
  public InactivityTimeout!: BehaviorSubject<number>;

  constructor(private httpService: HttpRequestService, private localTranslate: LocalTranslationService,
    private router: Router, private apiServiceProviderService: APIServiceProviderService,private _Is: InventoryService,
    private previlegeAuthorizationService: PrevilegeAuthorizationService, private azureConfig: ConfigService,private dialog: MatDialog,
    private receivingService: ReceivingService) {
    this.findUserAgent();
    this.viewPortHeight = window.innerHeight;
    this.syncedPercent = (localStorage.getItem('dataSyncedPercentage') !== undefined && localStorage.getItem('dataSyncedPercentage') !== null) ? localStorage.getItem('dataSyncedPercentage') : '0';
    this.InactivityTimeout = new BehaviorSubject<number>(this.getSessionInactivityTime());
  }
  public userAgent: string;
  public browser: string;
  public mobileBrowser = false;
  private processingPopupFlag = new BehaviorSubject<boolean>(false);
  private processingPopupMessage = new BehaviorSubject<string>('');
  public saveSessionCall = new BehaviorSubject<boolean>(false);
  public userBarCode : any;  
  CurrentFlagMessage = this.processingPopupMessage.asObservable();
  CurrentFlagValue = this.processingPopupFlag.asObservable();
  isFocusOut = false;
  public isPIFormDirty = false;
  public toogleOpen = false;
  public ReceivingMenu: any = 0;
  public ReceivingRouteUrl: any = '/receiving';
  public slideOpen = false;
  public expandMenu = false;
  public isBarcodeScan = false;
  public languageJson: any;
  public iconShow = false;
  public fromNav = false;
  public currenttabIndex = 0;
  public totalPrice = 0;
  public content: any;
  public locationData: any = [];
  public routeStack: any = ['/dashboard'];
  public siteAbbreviation: string;
  public userAbbreviation: string;
  public defaultSort: string;
  public selectedDropDown: string = appApiResources.SearchSourceType.SearchByInventory;
  public component: any;
  public poOriginalTableData:any = [];
  public requisitionSort: any;
  public transferSort: any;
  public AllrequisitionSort: any;
  public GenericReqSort: any;
  public sectionContainer: any;
  public bodyContainer: any;
  public filterOverlay: any;
  public isonlineStatus = true; // false;
  public issearchtriggered = false; // false;
  public onlineStatusChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public passcodePopupShow: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public tempPasscodePopupShow: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isCreateMessageSubscribe: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public isPasscodeExpiredsubscribe: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  public canshowpasscodepopup = false;
  public tempCanshowpasscodepopup = false;
  public isCreateMessage = true;
  public isPasscodeExpired = false;
  public isMasterSyncComplete = false;
  public expiryDays = '0';
  public AppInitialValueSet: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public showAppHeaderChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public MenuChangeToReq: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showReleaseNotesChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public activeMenuChange: BehaviorSubject<string> = new BehaviorSubject<string>('0');
  public showAppHeader = false;
  public showSettingLogin = true;
  public showSettingToast = false;
  public showSettingToastText = '';
  public searchValue = '';
  public IsLoginPage = false;
  public decimalDigits = 2;
  public isAllLocationsClick = false;
  public offlineTransactionId = 0;
  public offlineTransactiontype = 0;
  public isBackClick = false;
  public fromOfflineSync = false;
  public fromReqDetail = false;
  public showNewMessage = false;
  public noMathBack = false;
  public IsRguest = false;
  public rGuestUserName: string;
  public rGuestPassword: string;
  public rGuestLoginError: string = null;
  public offlineTabChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public debounceTime = 500;
  scrollHeight: number;
  viewPortHeight: number;
  public loaderComplete: boolean;
  public apiTime: BehaviorSubject<number> = new BehaviorSubject<number>(null);
  // public noMathData: object;
  public editedItem: any;
  public itemListData: any = [];
  public itemListFilter: any;
  addQuantity: boolean;
  updatedQuantity: number;
  public noMathHistory: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public uiMenu: any[] = [];
  public swipeDir = 'right';
  public qtyAllowNoOfDecimal = 6;
  public allowNoOfNumericDigitsInField = 10;
  appHeaderElementRef: ElementRef;
  appTittleElementRef: ElementRef;
  appTabHeaderElementRef: ElementRef;
  public fromDetailSection = false;
  public reachedSavePage = false;
  public isSettings = false;
  // For showing the edited element in focus
  public fromNoMath = false;
  public selectedIndex = 0;
  selectedMenu: string;
  selectedData: any;
  transactionHeaderForm: FormGroup;
  public deviceType: string = '';
  isOffline =false;
  directLogin = false;
  idToken:any;
  isreceivingDataAdded = false;
  offlineReceivingNavigation = false;
  isPhysicalEdit = false;
  syncedPercent:string = (localStorage.getItem('dataSyncedPercentage') !== undefined && localStorage.getItem('dataSyncedPercentage') !== null) ? localStorage.getItem('dataSyncedPercentage') : '0';
  tableName:string = (localStorage.getItem('tableName')!== undefined && localStorage.getItem('tableName')!== null) ? localStorage.getItem('tableName') : '';
  transferOriginalData: TransferDetailEntity[] = [];
  isReqFromTransfer = false;
  transferReqQtyData = [];
  public messageCount = new Subject;
  public disableEdit = new Subject;
  InventoryItemIds =[];
  Currencies:Array<any> = [];
  TransactionCurrencyCode = 164;
  PhysicalPostCont = false;
  isHighlightShow = true;
  public cumulative = false;
  public SystemConfig: any = {};
  @Output() scrollEventEmitter: EventEmitter<any> = new EventEmitter();
  public mobilePopUpProperty: any = {

    height: GlobalConst.popupConfig.popupheight,
    width: GlobalConst.popupConfig.popupwidth,
    panelClass: GlobalConst.popupConfig.panelClass,
    maxWidth: GlobalConst.popupConfig.maxWidth,
    disableClose: true,
    autoFocus: false
  };

  public titleOptions: Title = {
    'back': false,
    'pageTitle': '',
    'action': false,
    'innerHeader': false,
    'buttonText': '',
    'poRequisition': false,
    'edit': false,
    'more': false,
    'isReconcile': false
  };
  public apiUrl: string = window.localStorage.getItem('apiUrl');
  public searchChar: string = window.localStorage.getItem('searchChar');
  public quantityFocus: string = window.localStorage.getItem('quantityFocus');
  public LocalBarcodeScan: string = window.localStorage.getItem('LocalBarcodeScan');
  public deviceHasCamera = window.localStorage.getItem(appApiResources.HasCamera);
  public barcodeAutoIncrement: string = window.localStorage.getItem('barcodeAutoIncrement');
  public cumulativeCount: string = window.localStorage.getItem('cumulativeCount');
  public nonZero: string = window.localStorage.getItem('nonZero');
  public activeLocation: string = window.localStorage.getItem('activeLocation');
  public nonReported: string = window.localStorage.getItem('nonReported');
  public scansoundmode: string = window.localStorage.getItem('soundmode');
  public autoSync: string = window.localStorage.getItem('autoSync');
  public barCode: boolean = window.localStorage.getItem('newBarcode') == 'false' ? false : true ;
  public session: string = window.localStorage.getItem('session');
  public sessiontoggle: string = window.localStorage.getItem('sessionToggle') ?? 'true';
  public lastSync: string = moment().format();
  public version: string = window.localStorage.getItem('version');
  public readmoreData: any;
  public historyDetails: any;
  loggedInUserId = 0;
  RequisitionFormDetail: any;
  rguestLoginUrl: string;
  RGuestTenantId: any;
  RGuestProductId: any;
  RGuestTenantCode: string;
  public UserDetails: ApplicationUserEntity;
  public decimalFocusinLength = 6;
  public static decimalwholeNumberLength = 21;
  public static decimalvisibleLength = 4;
  public currencyFocusinLength = 4;
  public currencywholeNumberLength = 19;
  public currencyvisibleLength = 4;
  showPasswordExpiryMessage: boolean = false;
  public itemFocusIn = false;
  selectedqtyIndex = 0;
  InTransitFormDetails: any;
  customerList: any;
  selectedCustomerData: string;
  originalCustomerList: any = [];
  // public UIMenus: UIMenuEntity[] = [];

  getApprovalStatus() {
    let AuthorizationData = window.localStorage.getItem('IntegrationConfig');
    AuthorizationData = AuthorizationData !== 'undefined' ? JSON.parse(AuthorizationData) : null;
    return AuthorizationData ? AuthorizationData['DocApprovals'] === 'True' ? true : false : true;
  }

  getClassReqGenerator() {
    let AuthorizationData = window.localStorage.getItem('IntegrationConfig');
    AuthorizationData = AuthorizationData !== 'undefined' ? JSON.parse(AuthorizationData) : null;
    return AuthorizationData ? AuthorizationData['ClassReqGenerator'] === 'True' ? true : false : true;
  }

  calculateDueDate(postDate: any, payTermId: number, payTermDropdownList: Array<any>, isOnline: boolean): Observable<string> {
    if (!postDate) {
      return of(null);
    }

    const baseDate = moment(postDate).startOf('day');

    if (payTermId > 0 && isOnline) {
      return this.receivingService.GetPayTermById(payTermId).pipe(
        map(response => {
          const payTermResponse = Array.isArray(response?.value) ? response.value : Array.isArray(response) ? response : [];
          const dueDays = Number(payTermResponse?.[0]?.DueDays || 0);
          return moment(baseDate).add(dueDays, 'days').format();
        }),
        catchError(() => of(baseDate.format()))
      );
    } else if (payTermId > 0 && !isOnline) {
      const selectedPayTerm = (payTermDropdownList || []).find(x => x.Id === payTermId);
      const dueDays = Number(selectedPayTerm?.DueDays || 0);
      return of(moment(baseDate).add(dueDays, 'days').format());
    }

    return of(baseDate.format());
  }

  backClick = (arg) => {
    if (this.titleOptions.backFunction) {
      this.titleOptions.backFunction(arg, this.component);
    }
  }

  deleteClick = (arg) => {
    if (this.titleOptions.deleteFunction) {
      this.titleOptions.deleteFunction(arg, this.component);
    }
  }
  titleClick(arg) {
    this.titleOptions.titleClickFunction(arg, this.component);
  }

  actionClick(arg) {    
    this.titleOptions.actionClick(arg, this.component);
    this.transactionHeaderForm?.reset();
  }
  voiceAssistantActionClick(arg) {
    this.titleOptions.voiceAssistantActionClick(arg, this.component);
  }
  sendMailClick(arg) {
    this.titleOptions.sendMailClick(arg, this.component);
  }
  /*  loadOffline(arg){
     this.titleOptions.loadOffline(arg, this.component);
   } */
  loadSaved(arg) {
    this.titleOptions.loadSaved(arg, this.component);
  }
  editClick(arg) {
    this.titleOptions.editClick(arg, this.component);
  }
  moreOptionClick(arg) {
    this.titleOptions.moreOptionClick(arg, this.component);
  }

  syncClicked(arg) {
    this.titleOptions.syncClick(arg, this.component);
  }

  loadRequisitionEvent(arg) {
    this.titleOptions.loadRequisitionEvent(arg, this.component);
  }
  reconcile(arg) {
    this.titleOptions.reconcile(arg, this.component)
  }
  scrollEvent(event) {
    event.stopImmediatePropagation();
    this.scrollEventEmitter.emit(event);
  }

  onScroll = (event: any): void => {
    try {
      if (this.autoComplete?.panelOpen) {
        this.autoComplete?.closePanel();
        if(this.autoCompleteSearchText?.nativeElement) {
          this.autoCompleteSearchText.nativeElement.value = '';
        }
      }
    } catch (error) {
      console.error('Error occurred while closing the autocomplete panel', error);
    }
  };
  
  loadReq(arg) {
    this.titleOptions.loadReq(arg, this.component);
  }

  ChangeToogle(toogleboolean: boolean) {
    this.toogleOpen = toogleboolean;
  }

  routeClick(input: string) {
    if (input) {
      switch (input) {
        case 'message':
          this.router.navigate(['/message']);
          break;
      }
    }

  }

  refinedropdown(optios: any, transactions : any) {
    try {
    let count = 0;
    let arr = []
    const transtypes = [2, 3, 4, 5, 6, 7, 11]; //
    let filteredList = [];
    optios.forEach(Option => {
      filteredList = transactions?.filter(item => item.CapexId === Option.Id.toString()); //Option.Id.toString()
      transtypes.forEach(x => {
        if (x === 2) {
          const arr1 = filteredList?.filter(item => item.TransTypeId === x).map(_ => _.PoTotal);
          arr.push(...arr1);
          count = parseFloat(arr.reduce((a, b) => {
            return a + b;
          }, 0));
        } else if (x === 4) {
          const arr1 = filteredList?.filter(item => item.TransTypeId === x)?.map(_ => _.RequisitionHeaderDetail.InventoryHeadDetail.TotalAmount);
          arr.push(...arr1);
          count = parseFloat(arr.reduce((a, b) => {
            return a + b;
          }, 0));
        } else if (x === 3) {
          const arr1 = filteredList?.filter(item => item.TransTypeId === x).map(_ => _.TotalAmount);
          arr.push(...arr1);
          count += parseFloat(arr.reduce((a, b) => {
            return a + b;
          }, 0));
        } else if (x === 5) {
          const arr1 = filteredList?.filter(item => item.TransTypeId === x)?.map(_ => _.TransferHeadDetail.InventoryHeadDetail.TotalAmount);
          arr.push(...arr1);
          count = parseFloat(arr.reduce((a, b) => {
            return a + b;
          }, 0));
        } else if (x === 11) {
          const arr1 = filteredList?.filter(item => item.TransTypeId === x).map(_ => _.TotalAmount);
          arr.push(...arr1);
          count = parseFloat(arr.reduce((a, b) => {
            return a + b;
          }, 0));
        }
      });
      arr = [];
      Option.UnComittedAmount -= count;
      count = 0;
    });
    return optios;
    } catch(error) {
      console.error(error);
    }
  }
  GetInstances(): Observable<UserInstances[]> {
    return this.httpService.GetHttpRequest(apiURLs.GetInstance);
  }

  isCapexEnabel(config): boolean {
    try {
      const integrationDetails = localStorage.getItem('IntegrationConfig');
      const capexRequired = integrationDetails && integrationDetails !== 'undefined' ? JSON.parse(integrationDetails)[config] : this.tenatconfig ? JSON.parse(this.tenatconfig.integrationCofig)[config] : null;
      if (this.isonlineStatus) {
        if (!this.tenatconfig) {
          this.getTenantConfig();
        }
        return capexRequired === 'True'
      } else {
        return capexRequired === 'True';
      }
    } catch (error) {
      return false;
    }
  }

  async getTenantConfig() {
    try{
      if (this.isonlineStatus) {
        const tenant = localStorage.getItem('tenant');
        const x = await this.httpService.GetHttpRequest(`/tenantservice/api/TenantService/tenants?tenantIdentifier=${tenant.toLowerCase()}`).toPromise();
        this.tenatconfig = JSON.parse(x);
        this.tenatconfig.languageMasters.map((el)=>{
          el.id = el.languageCode
          el.value = el.languageName
          return el
        })
        localStorage.setItem('availableLanguage', JSON.stringify(this.tenatconfig.languageMasters));
        this.passwordComplexTenantConfig = [];
        sessionStorage.setItem('showLanguage', 'false');
        sessionStorage.setItem(appApiResources.IsConcurrentLoginIniConfigPresent, 'false');
        localStorage.setItem('EnableFullStoryMobile', 'False');
        this.tenatconfig.tenantINIConfig.forEach(config => {
          if (config.configKey === 'MobileUILongDateFormat') {
            localStorage.setItem('dateFormate', config.configValue);
          }
          if (config.configKey === 'UseSiteDecimalRoundOff' && config.isActive) {
            localStorage.setItem('UseSiteDecimalRoundOff', config.configValue);
          }
          if (config.configKey === 'EnableClassCalendarIntegration' && config.isActive) {
            localStorage.setItem('EnableClassCalendarIntegration', config.configValue);
          }
          if (config.configKey === 'Requisition#RequiredInTransferCreation' && config.isActive) {
            localStorage.setItem('RequisitionRequired', config.configValue);
          }
          if (config.configKey === 'Enable Recipe Extended Costs' && config.isActive) {
            localStorage.setItem('EnableRecipeExtendedCosts', config.configValue);
          }
          if (config.configKey === 'Activate Ack. Transfers' && config.isActive) {
            localStorage.setItem('ShowTransferAcknowledgement', config.configValue);
          } 
          if (config.configKey === 'Enable Edit Transfers' && config.isActive) {
            localStorage.setItem('EnableEditTransfers', config.configValue);
          }
          if (config.configKey === 'Reverse Physical Inventory' && config.isActive) {
            localStorage.setItem('ReversePhysicalInventory', config.configValue);
          }
          if (config.configGroup === 'PasswordValidation') {
            this.passwordComplexTenantConfig.push(config);
          }
          if (config.configGroup === 'Multilingual' && config.configKey === 'Show Language') {
            sessionStorage.setItem('showLanguage', String(config.configValue).toLowerCase() === 'true' ? 'true' : 'false');
          }
          if (config.configGroup === 'UserLogin' && config.configKey === 'Validate ConcurrentSessions') {
            sessionStorage.setItem(
              appApiResources.IsConcurrentLoginIniConfigPresent,
              String(config.configValue)?.toLowerCase() === 'true' ? 'true' : 'false'
            );
          }
          if (config.configKey === 'EnableFullStoryMobile' && config.isActive) {
            localStorage.setItem('EnableFullStoryMobile', config.configValue?.toString());
          }
          if (config.configKey === 'UILongDateFormat') {
            const UIDateFormat = (config?.configValue) ? config?.configValue?.toUpperCase() : 'MM/DD/YYYY'; // default to MM/DD/YYYY if configValue is null or undefined
            localStorage.setItem('IniDateFormat', UIDateFormat);
          }
        });
        localStorage.setItem('aiFeatureConfiguration', this.tenatconfig?.aiFeatureConfiguration);
        localStorage.setItem("TenantId",this.tenatconfig.id);
        localStorage.setItem('IntegrationConfig', this.tenatconfig.integrationCofig);
        localStorage.setItem('isCapexEnabel', this.isCapexEnabel('CapEx').toString());
        localStorage.setItem('editionId', this.tenatconfig.editionId);
        return this.tenatconfig.integrationCofig.CapEx === 'True';
      } else {
        return this.tenatconfig?.integrationCofig?.CapEx === 'True';
      }
    } catch(ex) {
      console.log(ex);
    }
  }


  offlinePostValidation(postModel:any) {
    try {
      if (postModel?.CapexId) {
        let count = 0;
        const transtypes = [2, 3, 4, 5, 6, 7, 11];
        transtypes.forEach(x => {
          if (x === 2 && postModel['PurchaseOrderDetails']) {
            const arr1 = postModel['PurchaseOrderDetails'].map(_ => _.Valued);
            count += parseFloat(arr1?.reduce((a, b) => {
              return a + b;
            }, 0));
          } else if (x === 4 && postModel['ReqDetails']) {
            const arr1 = postModel['ReqDetails'].map(_ => _.Valued);
            count += parseFloat(arr1?.reduce((a, b) => {
              return a + b;
            }, 0));
          } else if (x === 3 && postModel['SupplierTotal']) {
            count += postModel['SupplierTotal'];
          } else if (x === 5 && postModel['TransferDetails']) {
            const arr1 = postModel['TransferDetails'].map(_ => _.Valued);
            count += parseFloat(arr1?.reduce((a, b) => {
              return a + b;
            }, 0));
          } else if (x === 11 && postModel['SpoilageDetails']) {
            const arr1 = postModel['SpoilageDetails'].map(_ => _.Valued);
            count += parseFloat(arr1?.reduce((a, b) => {
              return a + b;
            }, 0));
          }
        });
        return count > this.unCommitedAmount
      } else {
        return false;
      }
    } catch( error) {
      return false;
    }
  }

  offlineDatePostValidation(postModel:any) {
    try {
      if (postModel?.CapexId && postModel?.PostDate) {
       const isValid = moment(this.ExpireDate).isSameOrAfter(postModel?.PostDate);
       return isValid;
       } else {
        return true;
      }
    } catch( error) {
      return false;
    }
  }
  
  getbaseUrl(e): Observable<any> {
    return this.httpService.GetHttpRequest(e);
  }

  GetSites(instancename): Observable<SiteEntity[]> {
    let params = new HttpParams();
    params = params.append('InstanceName', instancename);
    return this.httpService.GetHttpRequestId(params, apiURLs.GetSites);
  }

  GetMiscCharges() {
    return this.httpService.GetHttpRequest(apiURLs.TransactionManagement.GetMiscCharges);
  }
  // To Form Header JSON with given Structure
  formHDR_JSONContent(hdr) {
    const temparray = [];
    let tempOBJ = {};
    const leftFreeze = [];
    const centerContent = [];
    const rightFreeze = [];
    hdr.forEach((y, j) => {
      if (y.pane === 0) {
        leftFreeze.push({ 'dispName': y.dispName });
      } else if (y.pane === 1) {
        centerContent.push({ 'dispName': y.dispName });
      } else if (y.pane === 2) {
        rightFreeze.push({ 'dispName': y.dispName });
      } else {
        centerContent.push({ 'dispName': y.dispName });
      }
    });
    tempOBJ = {
      'RowData': '',
      'leftFreeze': leftFreeze,
      'centerContent': centerContent,
      'rightFreeze': rightFreeze,
    };
    temparray.push(tempOBJ);
    return temparray;
  }
  // To form CUSTOM Table Layout JSON
  formJSONContent(hdr, content) {

    const temparray = this.formHDR_JSONContent(hdr);
    let tempOBJ = {};
    const hdrKeyArray = Object.keys(content[0]);
    content.forEach((x, i) => {
      const leftFreeze = [];
      const centerContent = [];
      const rightFreeze = [];
      hdr.forEach((y, j) => {
        if (hdrKeyArray.indexOf(y['name']) !== -1) {
          if (y.pane === 0) {
            leftFreeze.push({ [y['name']]: x[y.name] });
          } else if (y.pane === 1) {
            centerContent.push({ [y['name']]: x[y.name] });
          } else if (y.pane === 2) {
            rightFreeze.push({ [y['name']]: x[y.name] });
          } else {
            centerContent.push({ [y['name']]: x[y.name] });
          }
        }
      });
      tempOBJ = {
        'RowData': x,
        'leftFreeze': leftFreeze,
        'centerContent': centerContent,
        'rightFreeze': rightFreeze,
      };
      temparray.push(tempOBJ);
    });
    return temparray;
  }
  setColumnFreeze() {
    const HDRCollection = document.getElementsByClassName('LeftFrzHDR');
    const HDRarr = Array.from(HDRCollection);
    let cellwidth = 0;
    HDRarr.forEach((hdr, i) => {
      cellwidth += document.getElementsByClassName('stickyfirstCol')[i].clientWidth;
      const indedxCollection = document.getElementsByClassName('cellLFIndex_' + (i + 1));
      const arr = Array.from(indedxCollection);
      arr.forEach(x => {
        x['style'].left = cellwidth + 'px';
      });
    });
  }

  getMenuItemList = () => {
   // const jsondata = (<any>menulist_data);
    // return jsondata.default;

    // now menu details are coming from API.

     let uiMenuJSON = [];
     uiMenuJSON = localStorage.getItem('uiMenus') ? JSON.parse(localStorage.getItem('uiMenus')) : [] ;

     return uiMenuJSON;
  }
  customCurrencyFormatter(val, style = true) {
    let b: any;
    if (val && val != null && val !== '') {
      b = val < 0 ? (-1 * val) : val;
      if (style) {
        b = this.apiServiceProviderService.utilityService.CurrencyFormatter.format(parseFloat(b));
      } else {
        b = this.apiServiceProviderService.utilityService.CurrencyFormatterWithOutStyle.format(parseFloat(b));
      }

      if (val < 0) {
        b = '-' + b;
      }
    } else {
      if (style) {
        b = this.apiServiceProviderService.utilityService.CurrencyFormatter.format(0);
      } else {
        b = this.apiServiceProviderService.utilityService.CurrencyFormatterWithOutStyle.format(0);
      }
    }

    return b;
  }
  async getUiMenus() {
    let menuList = [];
    if (sessionStorage.hasOwnProperty(appApiResources.loggedInUserId.toString())) {
      this.loggedInUserId = await parseInt(sessionStorage.getItem(appApiResources.loggedInUserId.toString()));
    }
    if (this.loggedInUserId > 0 ) {
      const MenuKeys = this.previlegeAuthorizationService.MenuKeys;
        if (MenuKeys !== null && MenuKeys.length > 0) {
          const MenuObjects = {
            'userId': this.loggedInUserId,
            'menuNames': MenuKeys
          };
        const response = await this.apiServiceProviderService.setupService.GetUserMenus(MenuObjects).toPromise();
          if (response && !response.hasOwnProperty('MessageType')) {
            this.UserDetails = response as ApplicationUserEntity;
            if (this.UserDetails && this.UserDetails.UIMenus && this.UserDetails.UIMenus.length > 0) {
              this.UserDetails.UIMenus.forEach(item => {
                menuList.push({
                  'name': item.Caption,
                  'routerLink': item.RoutingURL,
                  'icon': item.Icon,
                  'visible': item.Visible,
                  'enabled': item.Enabled
                });
              });
              if (this.UserDetails.GroupId.toString() === appApiResources.userGroup.Admin.toString() &&
              parseInt(sessionStorage.getItem(appApiResources.loggedInSiteId.toString())) === 0) {
                menuList.unshift({
                  'name': 'Manage Licenses',
                  'routerLink': '/manageLicence',
                  'icon': 'manage-license',
                  'visible': true,
                  'enabled': true
                });
                const licencemenuObject = new UIMenuEntity();
                licencemenuObject.Icon = 'manage-license';
                licencemenuObject.MenuId = 0;
                licencemenuObject.SortOrder = 0;
                licencemenuObject.Caption = 'Manage Licenses';
                licencemenuObject.RoutingURL = '/manageLicence';
                licencemenuObject.Visible = true;
                licencemenuObject.Enabled = true;
                this.UserDetails.UIMenus.unshift(licencemenuObject);
              }
            }
          } else {
            menuList =  (<any>menulist_data).default;
          }
        }
          if (menuList && menuList.length > 0) {
                localStorage.setItem('uiMenus', JSON.stringify(menuList));
          }
    }
  }


  BindPocketMenu(MenuItemResponse) {
    const uiMenuJSON = [];
    if (MenuItemResponse && !MenuItemResponse.hasOwnProperty('MessageType')) {
      this.UserDetails = MenuItemResponse as ApplicationUserEntity;
      if (this.UserDetails && this.UserDetails.UIMenus && this.UserDetails.UIMenus.length > 0) {
        this.UserDetails.UIMenus = this.UserDetails.UIMenus.filter(x => x.RoutingURL !== '/manageLicence');
        this.UserDetails.UIMenus.forEach(item => {
          uiMenuJSON.push({
            'name': item.Caption,
            'routerLink': item.RoutingURL,
            'icon': item.Icon,
            'visible': item.Visible,
            'enabled': item.Enabled
          });
        });
        if (uiMenuJSON && uiMenuJSON.length > 0) {
          localStorage.setItem('uiMenus', JSON.stringify(uiMenuJSON));
        }
      }
    }
  }
  GetIndex(array, property, value) {
    let index = -1;
    if (array && array.length > 0 && property && value) {
      array.forEach((item, idx) => {
        if (item[property] === value) {
          index = idx;
        }
      });
    }

    return index;

  }

  getFilterValues(filterArray, tableData) {
    filterArray.forEach(item => {
      item.innervalue = [];

      if (!item.jsonKey) {
        return;
      }

      const filterValues = _.uniq(tableData.map(row => row[item.jsonKey]));

      if (item?.filterType === 'toggle') {
        item?.innervalue?.push({
          id: 1,
          value: 'Enabled',
          checked: false,
          filterValue: true,
          key: item.jsonKey,
          sort: 'aesc'
        });
        return;
      }

      let hasBlank = false;
      filterValues.forEach((element, index) => {
        const isBlank = element === null || element === '' || element === 'None';
        if (isBlank) {
          hasBlank = true;
          return;
        }

        if (item?.jsonKey === 'dropShip') {
          item?.innervalue?.push({
            id: index,
            value: element === true ? 'Yes' : 'No',
            checked: false,
            filterValue: element,
            key: item.jsonKey,
            sort: 'aesc'
          });
        } else if (item?.payloadKey) {
          item?.innervalue?.push({
            id: index,
            value: String(element),
            checked: false,
            filterValue: element,
            key: item.jsonKey,
            payloadKey: tableData.find(row => row[item.jsonKey] === element)?.[item.payloadKey],
            sort: 'aesc'
          });
        } else {
          item?.innervalue?.push({
            id: index,
            value: String(element),
            checked: false,
            key: item.jsonKey,
            sort: item.jsonKey.toLowerCase() === 'date' ? 'desc' : 'aesc'
          });
        }
      });

      if (hasBlank) {
        item?.innervalue?.push({
          id: null,
          value: 'Blank',
          checked: false,
          filterValue: null,
          key: item.jsonKey,
          sort: 'aesc'
        });
      }
    });

    return filterArray;
  }

  GetDataForFilters(moduleId: number, param1: number = 0, param2: number = 1): Observable<any> {
    try {
      const endpoint = apiURLs.TransactionManagement.GetDataForFilters + `${moduleId}/${param1}/${param2}`;
      return this.httpService.GetHttpRequest(endpoint);
    } catch (error) {
      console.error('GetData For Filters error:', error);
      return of(null);
    }
  }

  generateParams(pop) {
    const newPop = pop.split('?')[1].replace(new RegExp('=', 'g'), ':'),
      params = {};
    newPop.split('&').forEach(element => {
      const abc = element.split(':');
      params[abc[0]] = decodeURI(abc[1]);
    });
    const navigationExtras: NavigationExtras = {
      queryParams: params
    };

    return navigationExtras;
  }

  OpenProcessingPopUp(message) {
    this.processingPopupFlag.next(true);
    this.processingPopupMessage.next(message);
  }
  closeProcessingPopUp() {
    this.processingPopupFlag.next(false);
  }

  setFilterArray(data, filterArray, serviceFilterArray) {
    const newFilter = this.getFilterValues(filterArray, data);
    if (this.iconShow) {
      serviceFilterArray.forEach((element, index) => {
        const uniq = newFilter[index].innervalue.filter(o => !element.innervalue.find(o2 => o.value === o2.value));
        uniq.forEach(r => r.checked = true);
        element.innervalue = element.innervalue.concat(uniq);
      });
      return serviceFilterArray;
    } else {
      return filterArray;
    }
  }

  /** Returns the checked display values for a given filter key */
  getCheckedValues(filterArray: any[], jsonKey: string): string[] {
    try {
      const filter = filterArray?.find(x => x.jsonKey === jsonKey);
      return filter?.innervalue?.filter((x: any) => x.checked)?.map((x: any) => x.value) ?? [];
    } catch (error) {
      console.error('getCheckedValues error:', error);
      return [];
    }
  }

  /** Returns the filterValue of the first checked item for a given filter key (e.g. dropShip boolean) */
  getCheckedFilterValue(filterArray: any[], jsonKey: string): any {
    try {
      const filter = filterArray?.find(x => x.jsonKey === jsonKey);
      if (filter?.filterType === 'toggle') {
        const toggleItem = filter?.innervalue?.[0];
        return !!toggleItem?.checked;
      }
      const item = filter?.innervalue?.find((x: any) => x.checked);
      return item != null ? item.filterValue : null;
    } catch (error) {
      console.error('getCheckedFilterValue error:', error);
      return null;
    }
  }

  /** Extracts a date range using start-of-day / end-of-day from a date filter in the array */
  buildDateRangeFilter(filterArray: any[], jsonKey = 'date'): { fromDate: string | null; toDate: string | null } {
    try {
      const dateFilter = filterArray?.find(x => x.jsonKey === jsonKey);
      if (dateFilter?.fromDate || dateFilter?.toDate) {
        return {
          fromDate: dateFilter.fromDate
            ? moment(dateFilter.fromDate).startOf('day').format('YYYY-MM-DDTHH:mm:ss')
            : null,
          toDate: dateFilter.toDate
            ? moment(dateFilter.toDate).endOf('day').format('YYYY-MM-DDTHH:mm:ss')
            : null
        };
      }
      return { fromDate: null, toDate: null };
    } catch (error) {
      console.error('buildDateRangeFilter error:', error);
      return { fromDate: null, toDate: null };
    }
  }

  hasActiveFilters(filterArray: any[]): boolean {
    try {
      return (filterArray ?? []).some((filter: any) =>
        filter?.innervalue?.some((item: any) => item?.checked) ||
        (filter?.filterType === 'daterange' && (filter?.fromDate != null || filter?.toDate != null))
      );
    } catch (error) {
      console.error('hasActiveFilters error:', error);
      return false;
    }
  }

  /** Maps checked display names to their corresponding IDs from originalData */
  extractIdsFromFilter(filterArray: any[], jsonKey: string, data: any[], nameField: string, idField: string): any[] {
    try {
      const checkedNames = this.getCheckedValues(filterArray, jsonKey);
      if (checkedNames.length === 0) { return []; }
      return (data ?? [])
        .filter(r => checkedNames.includes(r[nameField]))
        .map(r => r[idField])
        .filter((v: any, i: number, a: any[]) => v != null && a.indexOf(v) === i);
    } catch (error) {
      console.error('extractIdsFromFilter error:', error);
      return [];
    }
  }

  showLoader() {
    const loadingContainer: HTMLElement = document.getElementById('loading');
    const bodyContaier: HTMLElement = document.getElementsByTagName('body').item(0) as HTMLElement;
    loadingContainer.style.display = 'block';
    bodyContaier.style.filter = 'blur(0px)';
  }

  hideLoader() {
    const loadingContainer: HTMLElement = document.getElementById('loading');
    const bodyContaier: HTMLElement = document.getElementsByTagName('body').item(0) as HTMLElement;
    loadingContainer.style.display = 'none';
    bodyContaier.style.filter = 'blur(0px)';
  }

  OfflineUnSupportNevigation(module) {
    if (module === 'Requisition') {
      this.router.navigate(['/inventory/requisition']);
    } else if (module === 'Transfer') {
      this.router.navigate(['/transfer']);
    } else if (module === 'PurchaseOrder') {
      this.router.navigate(['/purchaseOrder/purchase']);
    }
  }

  /**
   * Reads and normalizes session/idle values in localStorage, then publishes idle seconds to InactivityTimeout.
   * Intended for app bootstrap (e.g. AppComponent) so ng-idle stays aligned with stored session prefs.
   */
  syncIdleTimeoutFromStoredSession(): void {
    const seconds = Number(this.getSessionInactivityTime());
    if (Number.isFinite(seconds)) {
      this.InactivityTimeout.next(seconds);
    }
  }

  getSessionInactivityTime(): number {
    appApiResources.normalizeLegacySessionIndex();
    const idx = appApiResources.resolveSessionPresetIndex();
    const secs = appApiResources.sessionPresetIndexToIdleSeconds(idx);
    localStorage.setItem('idleTimeout', String(secs));
    return secs;
  }

  findUserAgent() {
    const objAgent = navigator.userAgent;
    let objbrowserName = navigator.appName;

    if ((objAgent.indexOf('Edge')) !== -1) {
      objbrowserName = 'Microsoft Edge';
      } else if ((objAgent.indexOf('Chrome')) !== -1) {
      objbrowserName = 'Chrome';
      // objfullVersion = objAgent.substring(objOffsetVersion+7);
    } else if ((objAgent.indexOf('Trident/7.0')) !== -1) {
      objbrowserName = 'IE11 ';
      } else if ((objAgent.indexOf('Trident/6.0')) !== -1) {
      objbrowserName = 'Internet Explorer 10';
      } else if ((objAgent.indexOf('Trident/5.0')) !== -1) {
      objbrowserName = 'Internet Explorer 9';
      } else if ((objAgent.indexOf('Trident/4.0')) !== -1) {
      objbrowserName = 'Internet Explorer 8';
      } else if ((objAgent.indexOf('Firefox')) !== -1) {
      objbrowserName = 'Firefox';
      } else if ((objAgent.indexOf('Safari')) !== -1) {
      objbrowserName = 'Safari';
      }
      if ((objAgent.indexOf('Mobile')) !== -1) {
        this.mobileBrowser = true;
      }

  }

  getPlatform() {
    if ( /Android/i.test(navigator.userAgent) ) { this.inputType = 'tel';  }
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent) ) {this.inputType = 'number'; }
   }

   /**
     * @method loginAuthAlgorithm()
     * @input None
     * @Description login enable disbale Alogotrithm 
     */
  loginAuthAlgorithm( adDataInfo : any, ProductAuthentication: boolean ): LoginAuthentication {
    try {
        const azureAdType = ( adDataInfo && adDataInfo.AzureAdType ) ?  adDataInfo.AzureAdType : null;
        const enableProdAuthentication = ProductAuthentication;
        const loginAuthentication = {} as LoginAuthentication;
        if (azureAdType === null && enableProdAuthentication ) {
            loginAuthentication.HideAzureContainer = true;
            loginAuthentication.HideAgilysysAzureContainer = true;
            loginAuthentication.DisabledUserContainer = false;
            loginAuthentication.HideForgotPassword = false;
            loginAuthentication.HideForgotContainer = false;
        } else if (azureAdType && azureAdType === GlobalConst.AzureAdType.LDAP) {
            loginAuthentication.HideAzureContainer = true;
            loginAuthentication.HideAgilysysAzureContainer = true;
            loginAuthentication.DisabledUserContainer = false;
            loginAuthentication.HideForgotPassword = true;
            loginAuthentication.HideForgotContainer = true;
        } else if (azureAdType && (azureAdType === constants.AzureAdType.AZUREOPENID ||
          azureAdType === constants.AzureAdType.AZUREADSAML || azureAdType === constants.AzureAdType.WORKOSSSO)) {
          loginAuthentication.HideAzureContainer = false;
          loginAuthentication.HideAgilysysAzureContainer = false;
          loginAuthentication.DisabledUserContainer = false;
          loginAuthentication.HideForgotPassword = false;
        loginAuthentication.HideForgotContainer = false;
        }  else if (azureAdType && (azureAdType === GlobalConst.AzureAdType.CUSTOMERB2C ||
            azureAdType === GlobalConst.AzureAdType.PRODUCTB2C) && !enableProdAuthentication) {
            loginAuthentication.HideAzureContainer = false;
            loginAuthentication.HideAgilysysAzureContainer = false;
            loginAuthentication.DisabledUserContainer = true;
            loginAuthentication.HideForgotPassword = true;
            loginAuthentication.HideForgotContainer = false;
        } else if (azureAdType && (azureAdType === GlobalConst.AzureAdType.CUSTOMERB2C || azureAdType === GlobalConst.AzureAdType.PRODUCTB2C) && enableProdAuthentication) {
          loginAuthentication.HideAzureContainer = false;
          loginAuthentication.HideAgilysysAzureContainer = false;
          loginAuthentication.DisabledUserContainer = false;
          loginAuthentication.HideForgotPassword = true;
          loginAuthentication.HideForgotContainer = false;
        } 
        // For OnPrem Login as Agilysys Button is hidden
        if (localStorage.getItem('isOnPrem')?.toLowerCase() === 'true') {
          loginAuthentication.HideAgilysysAzureContainer = true;
        }
        return loginAuthentication;
    } catch (error) {
        console.error(error);
    }
  }

  clearDateRangeFilters(filterArray: any[]): void {
    try {
      if (!filterArray || !Array.isArray(filterArray)) {
        return;
      }
      const daterangeFilter = filterArray.find(f => f.filterType === 'daterange');
      if (daterangeFilter) {
        daterangeFilter.fromDate = null;
        daterangeFilter.toDate = null;
      }
    } catch (error) {
      console.error('clearDateRangeFilters error:', error);
    }
  }

  clearFilters(filterArray: any[], appliedDateFilter?: { fromDate?: any; toDate?: any }): void {
    try {
      // Clear all filters in the array
      if (filterArray && Array.isArray(filterArray)) {
        filterArray.forEach(f => {
          if (f.filterType === 'daterange') {
            f.fromDate = null;
            f.toDate = null;
          } else if (f.filterType === 'checkbox' && f.innervalue) {
            f.innervalue.forEach(item => item.checked = false);
          }
        });
      }
      // Clear individual date filter properties if provided
      if (appliedDateFilter) {
        appliedDateFilter.fromDate = null;
        appliedDateFilter.toDate = null;
      }
    } catch (error) {
      console.error('clearFilters error:', error);
    }
  }

  constractAdAuthority( AzureAdType: string, adModelObject: AdDataModel, MasterData: any ): string {
  try{
    let adAuthority: string = MasterData.authority
     if ( AzureAdType ){
          if( AzureAdType === constants.AzureAdType.LDAP ){
            adAuthority = MasterData.authority;
          } else if( AzureAdType === constants.AzureAdType.CUSTOMERB2C || AzureAdType === constants.AzureAdType.PRODUCTB2C ){
            const azureAdB2CUserflow :String = adModelObject.AzureAdB2CUserflow ? adModelObject.AzureAdB2CUserflow : adModelObject['AzureADB2CUserflow'];
            const azureAdB2CTenant :String = adModelObject.AzureAdB2CTenant ? adModelObject.AzureAdB2CTenant : adModelObject['AzureADB2CTenant'];
            adAuthority = `${adModelObject.AzureADB2CAuthority}/` + `${azureAdB2CTenant}/` + `${azureAdB2CUserflow}`;
          } else if( AzureAdType === constants.AzureAdType.AZUREADSAML){
            // adAuthority = adModelObject.AzureADB2CAuthority+`/${adModelObject.TenantId}/federationmetadata/2007-06/federationmetadata.xml?appid=`+`${adModelObject.ClientId}`;
            adAuthority = adModelObject.AzureADB2CAuthority+`/${adModelObject.TenantId}`;
          } else if( AzureAdType === constants.AzureAdType.AZUREOPENID ){
            adAuthority = adModelObject.AzureADB2CAuthority+`/${adModelObject.TenantId}`;
          }
          this.adAuthority = adAuthority;
          return adAuthority;
     }

  } catch(error){

    console.error(error);

  }

}
GatewayURL : Array<UrlConfig> = [
  {
    HostName:"https://eatec-mobileui-dev.rguest.com",
    Gateway:"https://eatec-apigateway-dev.rguest.com",
    PublisherServiceUrl:"https://eatec-publisher-dev.rguest.com/",
    WebUrl:"https://eatec-dev.rguest.com/#/",
    stage: "dev"
  },
  {
    HostName:"https://eatec-mobileui-qa.rguest.com",
    Gateway:"https://eatec-apigateway-qa.rguest.com",
    PublisherServiceUrl:"https://eatec-publisher-qa.rguest.com/",
    WebUrl:"https://eatec-qa.rguest.com/#/",
    stage: "qa"
  },
  {
    HostName:"https://eatec-mobileui-release.rguest.com",
    Gateway:"https://eatec-apigateway-release.rguest.com",
    PublisherServiceUrl:"https://eatec-publisher-release.rguest.com/",
    WebUrl:"https://eatec-release.rguest.com/#/",
    stage: "release"
  },
  {
    HostName:"https://eatec-mobile-release.rguest.com",
    Gateway:"https://eatec-apigateway-release.rguest.com",
    PublisherServiceUrl:"https://eatec-publisher-release.rguest.com/",
    WebUrl:"https://eatec-release.rguest.com/#/",
    stage: "eatec-release"
  },
  {
    HostName:"https://eatec-mobileui-prod-westus.onagilysys.com",
    Gateway:"https://eatec-apigateway-prod-westus.onagilysys.com",
    PublisherServiceUrl:"https://eatec-publisher-prod-westus.onagilysys.com/",
    WebUrl:"https://eatec-webui-prod-westus.onagilysys.com/#/",
    stage: "prodwestus"
  },
  {
    HostName:"https://eatec-mobile.onagilysys.com",
    Gateway:"https://eatec-apigateway.onagilysys.com",
    PublisherServiceUrl:"https://eatec-publisher.onagilysys.com/",
    WebUrl:"https://eatec.onagilysys.com/#/",
    stage: "onagilysys"
  },
  {
    HostName:"https://eatec-mobileui-sales.onagilysys.com",
    Gateway:"https://eatec-apigateway-sales.onagilysys.com",
    PublisherServiceUrl:"https://eatec-publisher-sales.onagilysys.com/",
    WebUrl:"https://eatec-webui-sales.onagilysys.com/#/",
    stage: "sales"
  },
  {
    HostName:"https://eatec-mobileui-prod-westus-staging.azurewebsites.net",
    Gateway:"https://eatec-apigateway-prod-westus-staging.azurewebsites.net",
    PublisherServiceUrl:"https://eatec-publisher-prod-westus-staging.azurewebsites.net/",
    WebUrl:"https://eatec-webui-prod-westus-staging.azurewebsites.net/#/",
    stage: "staging"
  },
  {
    HostName:"https://eatec-mobileui-devint.rguest.com",
    Gateway:" https://eatec-apigateway-devint.rguest.com",
    PublisherServiceUrl:"https://eatec-publisher-devint.rguest.com/",
    WebUrl:"https://eatec-webui-devint.rguest.com/#/",
    stage: "devint"
  },
  {
    HostName:"https://eatec-mobileui-qaint.rguest.com",
    Gateway:" https://eatec-apigateway-qaint.rguest.com",
    PublisherServiceUrl:"https://eatec-publisher-qaint.rguest.com/",
    WebUrl:"https://eatec-webui-qaint.rguest.com/#/",
    stage: "qaint"
  },
      {
    HostName:"https://aks-eatec-mobileui-qaint.rguest.com",
    Gateway:"https://aks-eatec-apigateway-qaint.rguest.com",
    PublisherServiceUrl:"https://aks-eatec-publisher-qaint.rguest.com/",
    WebUrl:"https://aks-eatec-webui-qaint.rguest.com/#/",
    stage: "aksqaint"
  },
      {
    HostName:"https://aks-eatec-mobileui-devint.rguest.com",
    Gateway:"https://aks-eatec-apigateway-devint.rguest.com",
    PublisherServiceUrl:"https://aks-eatec-publisher-devint.rguest.com/",
    WebUrl:"https://aks-eatec-webui-devint.rguest.com/#/",
    stage: "aks-devint"
  },
      {
    HostName:"https://aks-eatec-mobileui-dev.rguest.com",
    Gateway:"https://aks-eatec-apigateway-dev.rguest.com",
    PublisherServiceUrl:"https://aks-eatec-publisher-dev.rguest.com/",
    WebUrl:"https://aks-eatec-webui-dev.rguest.com/#/",
    stage: "aks-dev"
  },
      {
    HostName:"https://aks-eatec-mobileui-qa.rguest.com",
    Gateway:"https://aks-eatec-apigateway-qa.rguest.com",
    PublisherServiceUrl:"https://aks-eatec-publisher-qa.rguest.com/",
    WebUrl:"https://aks-eatec-webui-qa.rguest.com/#/",
    stage: "aks-qa"
  },
      {
    HostName:"https://eatec-mobile.onagilysys.eu",
    Gateway:"https://eatec-apigateway.onagilysys.eu",
    PublisherServiceUrl:"https://eatec-publisher.onagilysys.eu/",
    WebUrl:"https://eatec.onagilysys.eu/#/",
    stage: "aks-prod-westeu"
  },
    {
    HostName:"https://eatec-mobile-dr.onagilysys.eu",
    Gateway:"https://eatec-apigateway-dr.onagilysys.eu",
    PublisherServiceUrl:"https://eatec-publisher-dr.onagilysys.eu/",
    WebUrl:"https://eatec-dr.onagilysys.eu/#/",
    stage: "aks-prod-dr-westeu"
  }
]

getUTCDate(PostDate:any){
  const now = moment();
  return PostDate ? moment(PostDate).set({'hour': now.hour(),
  'minute': now.minute(),
  'second': now.second()})
  .utc().format() : null;
}
replaceCurrencySymbolToCode(value,extras){
  const currencyCode = appApiResources.CurrencySymbols?.filter(x => x.Id === extras)[0]
 return value.replace(currencyCode?.Symbol, currencyCode?.Code)
 }

 /***
 * @Method verify html sanity
 * @Input params html text 
 * @description sanitize html text
 * @Output return safe html
 */
 sanitizeInnerHtml(htmltext:string) {
  try {
    return DOMPurify.sanitize(htmltext);
  } catch (error) {
    console.log(error);      
  }
}

constructPayload(params: any) {
  try {
    const loggedInSiteId = parseInt(sessionStorage.getItem(appApiResources.loggedInSiteId.toString()));
    const loggedInUserId = parseInt(sessionStorage.getItem(appApiResources.loggedInUserId.toString()));
    const loggedInLocationIds = JSON.parse(sessionStorage.getItem('loggedInLocationId'));
    const Payload = {} as GetCallPayloadEntity
    Payload.FetchAll = false
    Payload.Skip = params.Skip
    Payload.Take = myGlobals.GetCallTake
    Payload.GetTotalRecCount = true
    Payload.IsActiveOnly = true
    Payload.SearchText = params.SearchText
    Payload.LookupField = ''
    Payload.orderByColumn = params.orderby
    Payload.orderByDirection = params.order
    Payload.IsMobile = true
    Payload.LocationIds = params.LocationIds || (Array.isArray(loggedInLocationIds) ? loggedInLocationIds : (loggedInLocationIds != null ? [loggedInLocationIds] : []))
    Payload.siteId = loggedInSiteId
    Payload.userId = loggedInUserId
    Payload.totalCount = 0
    return Payload
}
catch (error) {
  console.error(error);
}
}


constructResponseData(response: any) {
  if (response?.ResultData) {
    const result = Array.isArray(response.ResultData) ? response.ResultData[0] : response.ResultData;
    return result;
  } else {
    return response;
  }
}

constructInventoryDetailsPayload(params: any) {
  try {
    const Payload = {} as GetCallInvDetailsEntity
    Payload.FetchAll = false
    Payload.Skip = params.Skip
    Payload.Take = myGlobals.GetCallTake
    Payload.searchText = ''
    Payload.LookupField = params.LookupField
    Payload.orderByColumn = params.orderByColumn
    Payload.orderByDirection = 1
    Payload.FromDate = null
    Payload.ToDate = null
    Payload.IngredientId = +params.IngredientId
    Payload.TransTypeId = params.TransTypeId
    Payload.NeedExactValue = false
    return Payload
}
catch (error) {
  console.error(error);
}
}

constructClassesTypesPackagesPayload(params: any) {
  try {
    const loggedInSiteId = parseInt(sessionStorage.getItem(appApiResources.loggedInSiteId.toString()));
    const loggedInUserId = parseInt(sessionStorage.getItem(appApiResources.loggedInUserId.toString()));
    const Payload = {} as ClassesLookUpPost;
      Payload.FetchAll = true,
      Payload.LocationIds =  [],
      Payload.userId = loggedInUserId,
      Payload.siteId = loggedInSiteId,
      Payload.GetTotalRecCount = true,
      Payload.IsActiveOnly = true,
      Payload.LookupField = "Name",
      Payload.SearchText = params.searchText,
      Payload.totalCount = 0,
      Payload.orderByColumn = null,
      Payload.orderByDirection = 1,
      Payload.Skip = params.Skip,
      Payload.Take = myGlobals.InventoryLookUpTake,
      Payload.SearchByCategoryId = params.SearchByCategoryId,
      Payload.InventoryGroupCategoryId = 1,
      Payload.IsFromMasterLimit = false
      
      if (params?.FromLocationId > 0) {
        Payload['FromLocationId'] = params.FromLocationId;
      }
      if (params?.ToLocationId > 0) {
        Payload['ToLocationId'] = params.ToLocationId;
      }
      return Payload
}
catch (error) {
  console.error(error);
}
}

async getLoggedInDetails() {
  const loggedInDetails: { siteId?: number; userId?: number; userName?: string; locationId?: string } = {};

  const siteIdKey = appApiResources.loggedInSiteId.toString();
  const userIdKey = appApiResources.loggedInUserId.toString();
  const userNameKey = appApiResources.loggedInUserName.toString();
  const locationId = appApiResources.loggedInLocationId.toString();

  if (sessionStorage.hasOwnProperty(siteIdKey)) {
    loggedInDetails.siteId = parseInt(sessionStorage.getItem(siteIdKey) || '0');
  }
  if (sessionStorage.hasOwnProperty(userIdKey)) {
    loggedInDetails.userId = parseInt(sessionStorage.getItem(userIdKey) || '0');
  }
  if (sessionStorage.hasOwnProperty(userNameKey)) {
    loggedInDetails.userName = sessionStorage.getItem(userNameKey) || '';
  }
  if (sessionStorage.hasOwnProperty(locationId)) {
    loggedInDetails.locationId = sessionStorage.getItem(locationId) || '';
  }

  return loggedInDetails;
}

allocatedChargesCalc(details) {
  let total = 0;
  let UseId = 1;
  const selectedUse = details.selectedUse;
  const allocatedCharges = parseFloat(details.allocatedChargesValue.toString());
  const someChecked = details.gridData.some(x => x.isChecked);
  switch (selectedUse) {
    case 'Value':
      UseId = 2;
      details.gridData.forEach(element => {
        if ((someChecked && element.isChecked) || !someChecked) {
          element.Valued = element.Quantity * element.UnitCost;
          total += element.Valued;
        }
      });
      details.gridData.forEach(element => {
        if ((someChecked && element.isChecked) || !someChecked) {
          const percent = total ? (element.Valued || 0) / total : 0;
          element.Charges = (percent * allocatedCharges).toFixed(4);
          const val = parseFloat(element.Charges ? element.Charges.toString() : '0') * element.ExchangeRate;
          element.ChargesInFC =  parseFloat(val ? val.toString() : '0').toFixed(4);
        }
        element.UseId = UseId;
        if(element?.ReceivingItemsOtherTotals?.length) {
          this.receivingItemOtherDetails(element.ReceivingItemsOtherTotals, element, UseId);
        }
      });
      if(details?.facadeService) {
        details.facadeService.receivingTotalAmount = details.facadeService.getItemTotalAmount();
      }
      break;

    case 'Quantity':
      UseId = 3;
      total = (someChecked ? details.gridData?.filter(x => x.isChecked) : details.gridData).reduce((prev, element) =>
        prev + (parseFloat(element.Quantity) || 0), 0);
      details.gridData.forEach(element => {
        if ((someChecked && element.isChecked) || !someChecked) {
          const percent = total ? (parseFloat(element.Quantity) || 0) / total : 0;
          element.Charges = (percent * allocatedCharges).toFixed(4);
          const val = parseFloat(element.Charges ? element.Charges.toString() : '0') * element.ExchangeRate;
          element.ChargesInFC =  parseFloat(val ? val.toString() : '0').toFixed(4);
        }
        element.UseId = UseId;

        if(element?.ReceivingItemsOtherTotals?.length) {
          this.receivingItemOtherDetails(element.ReceivingItemsOtherTotals, element, UseId);
        }

      });
      if(details?.facadeService) {
        details.facadeService.receivingTotalAmount = details.facadeService.getItemTotalAmount();
      }
      break;

    case 'Unit Cost':
      UseId = 4;
      total = (someChecked ? details.gridData?.filter(x => x.isChecked) : details.gridData).reduce((prev, element) =>
        prev + (parseFloat(element.UnitCost) || 0), 0);
      details.gridData.forEach(element => {
        if ((someChecked && element.isChecked) || !someChecked) {
          const percent = total ? (parseFloat(element.UnitCost) || 0) / total : 0;
          element.Charges = (percent * allocatedCharges).toFixed(4);
          const val = parseFloat(element.Charges ? element.Charges.toString() : '0') * element.ExchangeRate;
          element.ChargesInFC =  parseFloat(val ? val.toString() : '0').toFixed(4);
        }
        element.UseId = UseId;
        if(element?.ReceivingItemsOtherTotals?.length) {
          this.receivingItemOtherDetails(element.ReceivingItemsOtherTotals, element, UseId);
        }
      });
      if(details?.facadeService) {
        details.facadeService.receivingTotalAmount = details.facadeService.getItemTotalAmount();
      }
      break;

    case 'Equal':
      UseId = 5;
      const equalCharge = (allocatedCharges / details.gridData.length).toFixed(4);
      details.gridData.forEach(element => {
        if ((someChecked && element.isChecked) || !someChecked) {
          element.Charges = equalCharge;
          const val = parseFloat(element.Charges ? element.Charges.toString() : '0') * element.ExchangeRate;
          element.ChargesInFC =  parseFloat(val ? val.toString() : '0').toFixed(4);
        }
        element.UseId = UseId;
        if(element?.ReceivingItemsOtherTotals?.length) {
          this.receivingItemOtherDetails(element.ReceivingItemsOtherTotals, element, UseId);
        }
      });
      if(details?.facadeService) {
        details.facadeService.receivingTotalAmount = details.facadeService.getItemTotalAmount();
      }
      break;

    case 'None':
      details.gridData.forEach(element => {
        element.ChargesInFC = '0.0000';
        element.Charges = '0.0000';
        element.UseId = UseId;
        if(element?.ReceivingItemsOtherTotals?.length) {
          this.receivingItemOtherDetails(element.ReceivingItemsOtherTotals, element, UseId);
        }
      });
      if(details?.facadeService) {
        details.facadeService.receivingTotalAmount = details.facadeService.getItemTotalAmount();
      }
      break;

    default:
      console.error("Invalid selected use value");
  }
}

  /**
     * Constructs a dynamic form configuration based on the response provided.
     * @param response - The response object containing form field data.
     */
  constructDynamicMiscForm(response: any[], formatter: number): any[] {
    try {
      const config = [];
      const deviceType = window.localStorage.getItem('deviceType');
      if (response && Array.isArray(response)) {
        const inputs = response.map((item) => ({
          type: 'input',
          label: item.Name,
          name: item.Id,
          placeholder: item.Name,
          id: item.Id + item.Name,
          directive: 'numberOnly',
          fieldFormatter: 'decimal',
          formatter,
          inputType: deviceType === 'iOS' ? 'text': this.inputType,
        }));
        config.push(...inputs);
      }

      return config;
    } catch (error) {
      console.error('Error constructing form:', error);
      return [];
    }
  }

receivingItemOtherDetails(ReceivingItemsOtherTotals, element, UseId) {
    const itemOtherTotals = ReceivingItemsOtherTotals || (element.ReceivingItemsOtherTotals = []);
    const allocatedChargeDetail = itemOtherTotals.find(x => x.CategoryId === 3);

    if (allocatedChargeDetail) {
      allocatedChargeDetail.Amount = element.Charges;
      allocatedChargeDetail.AmountInFC = element.ChargesInFC;
      allocatedChargeDetail.CategoryDetailId = UseId;
      return;
    }

    itemOtherTotals.push({
      Id: 0,
      CategoryId: 3,
      CategoryDetailId: UseId,
      Amount: element.Charges,
      AmountInFC: element.ChargesInFC
    });
}
  checkDataForZeroQtyTransactionWithRemark(data, remarkKey: string) {
    try {
      let returnValue = true;
      data?.forEach((el) => {
        if (el?.Qty && (el?.Qty !== 'null' && el?.Qty !== '' && el?.Qty !== 'undefined' && (parseFloat(el?.Qty) !== 0))) {
          returnValue = false;
        } else if (el[remarkKey]) {
          returnValue = false;
        }
      })
      return returnValue;
    } catch (error) {
      console.log(error);
    }
  }

  GetConsignmentBatches(Payload: any): Observable<any> {
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetIngredientConsignmentBatches, Payload);
  }

  GetConsignmentBatch(Payload: any): Observable<any> { // Inventory details tab
    return this.httpService.postHttpRequest(apiURLs.TransactionManagement.GetConsignmentBatches, Payload);
  }

  openBatchClearConfirmation(tableData: any[], translateService: any, control: any, oldLocationId: any) {
    const dialogArray = {
      headerText: translateService.instant('common.warning'),
      contentText: translateService.instant('common.ConsignmentWarningLocation'),
      cancelText: translateService.instant('common.no'),
      confirmText: translateService.instant('common.yes'),
      confirmHelpText: 'yes',
      cancelHelpText: 'no',
    };

    this.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent, this.mobilePopUpProperty);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        tableData.forEach((row: any) => (row.ConsignmentBatch = []));
      } else {
        control.setValue(oldLocationId, { emitEvent: false });
      }
    });
  }

  itemListClearConfirmation(translateService: any, moduleName: string): Promise<boolean> {
    const dialogArray = {
      headerText: translateService.instant('common.Confirmation'),
      contentText: translateService.instant('common.ConsignmentWarningToggle', { module: moduleName }),
      cancelText: translateService.instant('common.no'),
      confirmText: translateService.instant('common.yes'),
      confirmHelpText: 'yes',
      cancelHelpText: 'no',
    };

    this.mobilePopUpProperty.data = dialogArray;
    const dialogRef = this.dialog.open(PopupComponent, this.mobilePopUpProperty);

    return new Promise((resolve) => {
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'yes') {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }


}


